import { render } from "./LoanStatus.vue?vue&type=template&id=4e8473f3&scoped=true"
import script from "./LoanStatus.vue?vue&type=script&lang=js"
export * from "./LoanStatus.vue?vue&type=script&lang=js"

import "./LoanStatus.vue?vue&type=style&index=0&id=4e8473f3&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e8473f3"]])

export default __exports__